import axios from 'axios';
import Cookie from './_cookie';

const wishlist = {
    products: JSON.parse(Cookie.get('wishlist')) || [],
};

wishlist.containsProduct = url => wishlist.products.some(productUrl => productUrl === url);

wishlist.addProduct = url => {
    if(!wishlist.containsProduct(url)) {
        wishlist.products.push(url);

        Cookie.set('wishlist', JSON.stringify(wishlist.products), 365);
    }
};

wishlist.removeProduct = url => {
    if(wishlist.containsProduct(url)) {
        const index = wishlist.products.findIndex(productUrl => productUrl === url);
        wishlist.products.splice(index, 1);

        Cookie.set('wishlist', JSON.stringify(wishlist.products), 365);
    }
};

wishlist.toggleProduct = url => {
    if(wishlist.containsProduct(url)) {
        wishlist.removeProduct(url);
    } else {
        wishlist.addProduct(url);
    }

    return wishlist.products.count;
};

wishlist.fetchProduct = async url => {
    // let response = await axios.get(`${urlPrefix}${url}.html?wishlist=true`);
    //
    // if(response.status === 200) {
    //     return response.data.split('--WISHLIST--')[1];
    // }
};

export default wishlist;
